import React from 'react';
import { IconButton } from '@mui/material';
import {
  Leaderboard as LeaderboardIcon,
  Close as CloseIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import SidebarPanelHeader from '../SidebarPanelHeader';

interface ProspectClassificationPanelHeaderProps {
  onClose: () => void;
  onEdit?: () => void;
  showEditButton?: boolean;
}

const ProspectClassificationPanelHeader: React.FC<
  ProspectClassificationPanelHeaderProps
> = ({ onClose, onEdit, showEditButton = false }) => {
  const editButton =
    showEditButton && onEdit
      ? [
          <IconButton
            key="edit"
            size="small"
            onClick={onEdit}
            sx={{ color: 'text.secondary' }}
            title="Edit configuration"
            aria-label="Edit configuration"
          >
            <EditIcon fontSize="small" />
          </IconButton>
        ]
      : [];

  return (
    <SidebarPanelHeader
      icon={<LeaderboardIcon />}
      title="Prioritize Prospects"
      infoTooltip="Configure how your company prospects are prioritized. Choose tiering (custom labels with criteria), qualifying (qualified vs unqualified rules), or scoring (how to rank your prospects)."
      titleVariant="custom"
      sx={{ mb: 0 }}
      actionButtons={[
        ...editButton,
        <IconButton
          key="close"
          size="small"
          onClick={onClose}
          aria-label="Close panel"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ]}
    />
  );
};

export default ProspectClassificationPanelHeader;
